import styled, { css } from "styled-components";

import { normalizeCssSize, type IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

export const TableHeaderCellReportStyled = styled.th.attrs<IStyledAttributes>({
  "data-e2e": "table-header-report-cell",
})<{ $columnWidth?: string | number }>`
  position: relative;
  padding: 6px;
  font-weight: 700;
  font-size: 12px;
  text-align: left;
  color: ${rydeColors.black};
  border-top: 1px solid ${greyMui._300};
  div.th_content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-height: 18px;
    span {
      width: 100%;
    }
  }

  ${({ $columnWidth }) =>
    $columnWidth
      ? css`
          width: ${normalizeCssSize($columnWidth)};
        `
      : css`
          max-width: 200px;
        `}
  &:first-child {
    border-start-start-radius: 3px;
  }
  &:last-child {
    border-start-end-radius: 3px;
  }
`;
